module.exports = __webpack_public_path__ + "img/MAC1132_R.ea882221.png";